import type { IResource, IResourceData } from '@/entities';

export * from './resource.types';

export class Resource implements IResource {
  id: string = '';
  header: string = '';
  description: string = '';
  imageUrl: string = '';
  order: number = 0;
  url: string = '';

  constructor(data: IResourceData) {
    Object.assign(this, data);
  }
}
